import React, { FunctionComponent } from "react";
import { Button } from "Shared/Buttons";
import Msrp from "Shared/Msrp/index";
import VinNumber from "src/components/VinNumber/VinNumber";
import styled from "styled-components";
import { AccountState, VehicleState } from "Types/state";

const Container = styled(Button)`
    &&& {
        border: 0;
        display: inline-block;
        letter-spacing: normal;
        line-height: 1;
        padding: 0;
        text-align: left;
    }
`;

const Content = styled("div")`
    border: 0;
    border-bottom: solid 0.5px #cecece;
    display: flex;
    margin: 0 15px;
    padding: 20px 0;
`;

const Img = styled("img")`
    border: solid 1px #d6d4d0;
    font-family: "object-fit: cover;";
    height: 80px;
    object-fit: cover;
    width: 107px;
`;

const Details = styled("div")`
    display: inline-block;
    font-size: 1em;
    font-weight: normal;
    margin-left: 1em;
    vertical-align: top;
`;

const Text = styled("span")`
    display: block;
    font-size: 14px;
    font-weight: normal;
    margin-top: 8px;
    text-transform: uppercase;
`;

const TextLight = styled("span")`
    color: ${(props) => props.theme.palette.grey[20]};
    font-size: 13px;
    font-weight: normal;
`;

export const MSRPWithPrice = styled(TextLight)<{ showStrikethrough: boolean }>`
    text-decoration: ${(props) => (props.showStrikethrough ? "line-through" : "none")};
`;

export interface FlyoutListItemProps {
    account: AccountState;
    onOpenGarage: () => void;
    vehicle: VehicleState;
}

const FlyoutListItem: FunctionComponent<FlyoutListItemProps> = ({ onOpenGarage, vehicle }) => {
    return (
        <li key={`os_flyout_garage_${vehicle.vin}`} className="garage-vehicle-item">
            <Container onClick={onOpenGarage}>
                <Content>
                    <Img src={vehicle.thumbnail} />
                    <Details>
                        {vehicle.title}
                        <br />
                        <VinNumber>{vehicle.vin}</VinNumber>
                        <br />
                        <Text>
                            <Msrp vehicle={vehicle} />
                        </Text>
                    </Details>
                </Content>
            </Container>
        </li>
    );
};

export default FlyoutListItem;
